import { oz } from '@weft/utils';
import { ContractPageDataSchema } from '../../../shared-schemas';

export const GetContractPageDataResponseSchema = oz.object({
  contractPageData: ContractPageDataSchema,
}).openapi('GetContractPageDataResponse');

export type GetContractPageDataResponse = oz.infer<typeof GetContractPageDataResponseSchema>;